// Location-events display helpers shared across the calendar, the daily
// banner, and the events settings surface.

// Format an event's date range as "YYYY-MM-DD" or "start → end".
export function eventDateRange(e) {
  const s = String(e.start_date || '').slice(0, 10);
  const en = String(e.end_date || '').slice(0, 10);
  if (!en || en === s) return s;
  return `${s} → ${en}`;
}
